import { useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { UseI18n } from '../../../common/hooks/useI18n'
import { TextEllipsisStaticLine } from '../../../common/textEllipsis/TextEllipsisStaticLine'
import { formatVal } from '../../../helpers/value'

export const TranslateCompanies = ({ count, props }) => {
  const locale = useSelector((state) => state.i18n.locale)
  const formatCount = formatVal(count, locale, false, 0)

  if (count < 2) {
    return (
      <Translate
        value="dashboard.creditRisk.company"
        count={formatCount}
        {...props}
      />
    )
  }
  return (
    <Translate
      value="dashboard.creditRisk.companies"
      count={formatCount}
      {...props}
    />
  )
}

export const TranslateExpiryDay = ({ count }) => {
  const locale = useSelector((state) => state.i18n.locale)
  const formatCount = formatVal(count, locale, false, 0)
  const textLimit = UseI18n('dashboard.currentPlan.noLimit')

  if (count === null)
    return <TextEllipsisStaticLine text={textLimit} lineClamp={1} />
  if (count < 2)
    return (
      <Translate value="dashboard.currentPlan.expiryDay" count={formatCount} />
    )
  return (
    <Translate value="dashboard.currentPlan.expiryDays" count={formatCount} />
  )
}

export const TranslateDay = ({ count }) => {
  const locale = useSelector((state) => state.i18n.locale)
  const formatCount = formatVal(count, locale, false, 0)

  if (count < 2)
    return <Translate value="dashboard.currentPlan.day" count={formatCount} />
  return <Translate value="dashboard.currentPlan.days" count={formatCount} />
}
